
export default function Error() {
    return <a href='/'><h1>Contactarse con el administrador</h1></a> 
}